<template src="../../../../agilis/mobile/TrackerDataTableMobile/TrackerDataTablePaginatedMobile.html" />

<script>
import TrackerDataTablePaginatedMobile from '@/agilis/mobile/TrackerDataTableMobile/TrackerDataTablePaginatedMobile'

export default {
  name: 'PropositionTableMobile',
  mixins: [TrackerDataTablePaginatedMobile]
}
</script>
